// IMPORTANT: Build gql after ANY changes to queries (client OR api)
import { graphql } from '@/client/services/api/graphql/gql/gql';

export const listGroupsQuery: any = graphql(`
  query ListSegmentationGroups(
    $id: IDQueryOperatorArgs
    $includeTotalCount: Boolean! = true
    $name: StringQueryOperatorArgs
    $ordering: [OrderBy!]
    $page: Int! = 0
    $pageSize: Int! = 50
  ) {
    listSegmentationGroups(
      id: $id
      includeTotalCount: $includeTotalCount
      name: $name
      ordering: $ordering
      page: $page
      pageSize: $pageSize
    ) {
      edges {
        node {
          createdAt
          description
          externalId
          id
          name
          updatedAt
          __typename
        }
      }
    }
  }
`);
